// ComingSoon.js
import React from 'react';
import { FaSun } from 'react-icons/fa';

function ComingSoon() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-gradient-to-b from-blue-400 to-gray-800 relative overflow-hidden text-white">
      
      {/* Sun with glowing animation */}
      <div className="relative group animate-solarPulse">
        <FaSun className="text-yellow-400 text-[10rem] drop-shadow-lg transition-transform duration-300 ease-in-out group-hover:scale-110" />
        {/* Solar Pulse Waves */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-48 w-48 rounded-full bg-yellow-300 opacity-20 animate-solarWave group-hover:opacity-50"></div>
          <div className="h-60 w-60 rounded-full bg-yellow-200 opacity-10 animate-solarWave delay-100 group-hover:opacity-40"></div>
          <div className="h-72 w-72 rounded-full bg-yellow-100 opacity-5 animate-solarWave delay-200 group-hover:opacity-30"></div>
        </div>
      </div>

      {/* Particle Animation */}
      <div className="absolute h-1 w-96 top-1/2 left-1/2 bg-transparent overflow-hidden transform -translate-x-1/2 -translate-y-1/2 animate-particleFlow">
        <div className="particle"></div>
      </div>

      {/* Floating Solar Panels */}
      <div className="absolute bottom-12 flex space-x-6 w-full justify-center items-center">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="h-20 w-14 bg-gray-800 rounded transform shadow-lg animate-panelFloat"
            style={{ animationDelay: `${index * 0.2}s` }}
          />
        ))}
      </div>

      {/* Text Overlay */}
      <div className="text-center mt-8 animate-fadeIn">
        <h1 className="text-6xl font-bold mb-4">Powering Up Soon</h1>
        <p className="text-xl font-medium">Bringing sustainable energy to your fingertips.</p>
      </div>
    </div>
  );
}

export default ComingSoon;
